import { ClipLoader } from 'react-spinners';
import s from './LoadingInside.module.scss';

const Loading = ({ height }) => {
  return (
    <div className={s.loadingWrapper} style={{height : height}}>
        <img
            src="/loader.gif"
            alt="Loading..."
            className={s.loaderGif}
        />
    </div>
  );
};

export default Loading;
